<template>
  <div id="component-chat-log" class="chat-message-box-inner m-8" v-if="allMessages">
    <div v-for="m in previousChatMessages" class="msg-grp-container" :key="'prev_' + m.id + '::' + m.order">
      <ChatMemberAvatar
        :member="member(m)"
        :isOwner="m.isOwner"
      />
      <!-- <div class="flex items-start" :class="[{'flex-row-reverse' : msg.isSent}]"> -->
      <div>
        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm bg-primary-gradient text-white"
        >
          <span v-if="!m.isOwner">{{ senderName(m) }}</span>
          <span>
            {{ m.content }}
          </span>
          <span class="message-timestamp">
            {{ m.dateFormat }}
          </span>
        </div>
      </div>
    </div>

    <div v-for="m in chatMessages" class="msg-grp-container" :key="m.id + '::' + m.order">
      <div class="message-item-container flex items-start mb-1 pb-2" :class="[{'flex-row-reverse' : m.isOwner }]">
        <ChatMemberAvatar
          :member="member(m)"
          :isOwner="m.isOwner"
          class="pt-1"
        />
        <!-- :class="[{'items-end' : message(m, i).isOwner }]" -->
        <div
          class="message-box msg break-words relative shadow-md rounded mx-2 pt-3 pb-4 px-4 rounded-lg max-w-sm bg-white"
          :class="{
            'bg-primary-gradient text-white': m.isOwner,
            'flex flex-col-reverse justify-end items-end': m.isOwner  
          }"
        >
          <div class="w-full justify flex flex-inline"
            :class="m.isOwner ? 'text-white justify-end items-end' : 'justify-between items-center mb-2'"  
          >
            <span v-if="!m.isOwner" class="text-primary mr-16">{{ senderName(m) }}</span>
            <span v-if="m.isDateValid"
              class="message-timestamp"
              :class="m.isOwner ? 'mt-2' : 'mt-1'"
            >
              {{ m.dateFormat }}
            </span>
          </div>
          <span>
            {{ m.content }}
          </span>
        </div>
      </div>
    </div>

    <div v-for="message in processingQueue" class="msg-grp-container" :key="message.id">
      <div class="flex items-start flex-row-reverse">
        Sending...
        <div
          class="msg break-words relative shadow-md rounded pt-3 pb-4 px-4 mb-2 rounded-lg max-w-sm border border-solid border-transparent bg-white"
        >
          <span>
            {{ message.content }} 
          </span>
        </div>
      </div>
    </div>

    <div v-for="message in sendingQueue" class="msg-grp-container" :key="message.id">
      <div class="flex items-start flex-row-reverse">
        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm border border-solid border-transparent bg-white"
        >
          <span>
            {{ message.content }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  components: {
    ChatMemberAvatar: () => import("./ChatMemberAvatar")
  },
  props: {
    allMessages: {
      type: Object,
      default: null
    },
    members: {
      type: Array,
      default: null
    }
  },
  computed: {
    chatMessages() { return this.allMessages.chatMessages.map((message, index) => this.messageFormatter(message, index, this.allMessages.chatMessages)) },
    previousChatMessages() { return this.allMessages.previousChatMessages.map((message, index) => this.messageFormatter(message, index, this.allMessages.previousChatMessages)) },
    sendingQueue() { return this.allMessages.sendingQueue.map((message, index) => this.messageFormatter(message, index, this.allMessages.processingQueue)) },
    processingQueue() { return this.allMessages.processingQueue.map((message, index) => this.messageFormatter(message, index, this.allMessages.sendingQueue)) },
    // message() {
    //   const messages = this.allMessages.chatMessages;
    //   return (message, index) => this.messageFormatter(message, index, messages);
    // },
    // prevMessage() {
    //   const messages = this.allMessages.previousChatMessages;
    //   return (message, index) => this.messageFormatter(message, index, messages);
    // },
    senderName() {
      return (message) => {
        // if (message && index && messages) {
          // let prevMessage = messages[index > 0 ? index - 1 : index];
          // const nextMessage = this.nextMessage(message, index, messages);
          // const prevMessage = this.prevMessage(message, index, messages);

          // if (message.senderUUID === prevMessage.userUUID) return null
          if (this.$flatmap.has(message.senderUUID)) {
            return this.$flatmap.get(message.senderUUID).fullname;
          }
          return "Unknown"
        // }
        // return null
      }
    },
    member() {
      return (message) => this.members.find(member => member.uuid === message.senderUUID); 
    },
    isOwner() {
      return (message) => message.senderUUID === this.$currentUser.uuid ? true : false;
    },
    dateFormat() {
      return (message, index, messages) => {
        // const prevMessage = 
        //   index === 0
        //   ? null
        //   : messages[index === messages.length - 1 ? index - 5 : index > 0 ? index - 1 : index ];
        // if (prevMessage && (message.timestamp - prevMessage.timestamp < 120000) && message.senderUUID === prevMessage.senderUUID) return null

        // Use next message to check whether to show message time or not (if the current message's time is the same as the next one)
        const nextMessage = this.nextMessage(message, index, messages);
        if (nextMessage && (nextMessage.timestamp - message.timestamp < 60000) && message.senderUUID === nextMessage.senderUUID) return null;

        return !message.timestamp
          ? null
          : new Date(message.timestamp).getDate() === new Date().getDate()
          ? "Today" + moment(new Date(message.timestamp)).format(" @ HH:mm")
          : moment(new Date(message.timestamp)).format("YYYY MMM DD @ HH:mm")
      }
    }
  },
  methods: {
    messageFormatter(message, index, messages) {
      const isOwner = message.senderUUID === this.$currentUser.uuid;
      const senderUUID = message.senderUUID;
      const senderName = this.senderName(message);
      const dateFormat = this.dateFormat(message, index, messages);
      const isDateValid = message.timestamp ? true : false

      return {
        ...message,
        isOwner,
        isDateValid,
        senderUUID,
        senderName,
        dateFormat
      }
    },
    nextMessage(message, index, messages) {
      return index < messages.length - 1 ? messages[index + 1] : null
    },
    prevMessage(message, index, messages) {
      return index === 0 ? null
        : messages[index === messages.length - 1 ? index - 5 : index > 0 ? index - 1 : index ];
    }
  },
  mounted() {
    this.$flatmap.store();
  }
}
</script>

<style lang="scss">
.message-item-container {
  & .message-box {
    min-width: min-content;

  }
  & .message-timestamp {
    font-size: 0.7rem !important;
    // position: absolute;
    // right: 0;
    // bottom: -10rem;
    min-width: min-content;
  }
}
</style>